
import Vue from "vue";
import { apiConstants } from "../../config";
import { apiPost, apiPut, apiGet, apiDelete } from "../../../../shared/services";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const fetchEvents = options => {
  const url = apiConstants.events;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

export { fetchItems, saveItem, deleteItem, fetchItem, fetchEvents };
